import { render, staticRenderFns } from "./DecisionMakingDepartment.vue?vue&type=template&id=c6919a58&"
import script from "./DecisionMakingDepartment.vue?vue&type=script&lang=ts&"
export * from "./DecisionMakingDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionMakingDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports